@let tolOptions = tol();
@if (isLoading() || !tolOptions) {
  <clr-spinner class="centred" />
} @else {
  <div class="d-f col h-100">
    <div>
      @if (!skizzeRs.error() && skizzeRs.value(); as base64) {
        <span>{{ 'Skizze' | mrTranslate }}</span>
        <br />
        <app-image-slide-show [data]="[{ base64, name: zaehlerName().Bild }]" invert height="25vh" />
      }
    </div>
    @if (checklist().columns | filterTolByOptions: zaehlerName(); as columns) {
      <clr-datagrid [clrDgItemsIdentityFn]="row => row?.ID" class="datagrid-compact sticky-action-column h-auto">
        @if (messungen().length >= 2) {
          <clr-dg-column class="mw-0">{{ 'Vgl.' | mrTranslate }}</clr-dg-column>
        }
        @for (column of columns; track column.id) {
          <clr-dg-column>
            <ng-container
              *clrDgHideableColumn="{
                hidden:
                  column.id
                  | hideIDColumns
                    : [
                        'szaehnid',
                        'i_sort',
                        'zeinheit',
                        'username',
                        'status',
                        'zart',
                        'ztype',
                        'sgenau',
                        'tgenau',
                        'aktivsrlimm',
                        'aktivsr100',
                        'aktivsrg',
                        'lastid',
                      ],
              }">
              {{ column.id | transformColNames: tolOptions | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        @for (group of messungen(); track group.pruefung.OPRUEFID) {
          <clr-dg-column>{{ 'Ist' | mrTranslate }} - {{ group.pruefung.Column_Datum }}</clr-dg-column>
          <clr-dg-column>{{ 'Tol. Verl.' | mrTranslate }} - {{ group.pruefung.Column_Datum }}</clr-dg-column>
          <clr-dg-column>{{ 'Bemerkung' | mrTranslate }} - {{ group.pruefung.Column_Datum }}</clr-dg-column>
        }
        <clr-dg-row
          *clrDgItems="let row of checklist().rows; let i = index"
          [clrDgItem]="row"
          [class.headerRow]="row.ZType == ZType_Header">
          @if (messungen().length >= 2) {
            <clr-dg-cell class="mw-0">
              <a href="javascript:void(0)" (click)="findMessungInGroups(row)">
                <cds-icon shape="line-chart" size="20" />
              </a>
            </clr-dg-cell>
          }
          @for (cell of columns; track cell.id) {
            <clr-dg-cell class="name-cell" [class.sticky-action]="cell.id == 'Code'">
              {{ row | werteRowValues: cell.id | tablePrettyPrint }}
            </clr-dg-cell>
          }
          <ng-container>
            @for (group of messungen(); track group.pruefung.OPRUEFID) {
              <clr-dg-cell class="name-cell">{{ group.messwerte[i]?.Ist }}</clr-dg-cell>
              <clr-dg-cell class="noover">
                @if (group.messwerte[i]?.Ausfall; as ausfall) {
                  <span class="label ausfall" [style.--ausfall-color]="ausfall | getAusfallColor: tolOptions">
                    {{ ausfall }}
                  </span>
                }
              </clr-dg-cell>
              <clr-dg-cell class="name-cell">{{ group.messwerte[i]?.Bemerkung }}</clr-dg-cell>
            }
          </ng-container>
        </clr-dg-row>
        <clr-dg-footer>{{ checklist().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
  </div>

  <app-messung-vergleich [(row)]="selectedRow" [tol]="tolOptions" />
}
